<template>
  <v-app>
    <div class="padding-card grey">
      <v-row>
        <v-col cols="5">
          <v-card class="padding-card">
            <span>Monto de egresos del periodo</span>
            <p class="title-modal">{{
              $currencyNoDec.format(total)
            }}</p>
          </v-card>

          <v-card class="padding-card" style="padding-bottom:30px; margin-top:40px">
            <p class="title-user-scr-b">Registrar nuevo egreso</p>
            <RegisterSpendForm @on-save="fetchPayments(dates)" />
          </v-card>
        </v-col>
        <v-col cols="7">
          <v-container>
            <v-row>
              <v-col>
                  <DateSelect :initialRage="dates" @change="fetchPayments" />
              </v-col>
              <v-col>
                <router-link to="/spendreportform">
                  <v-btn 
                    depressed 
                    style="margin-left: 10px;"
                    color="primary"                    
                  >Reportes</v-btn>  
                </router-link>                             
              </v-col>
            </v-row>
           
            <v-row dense>             
              <v-col v-for="(spend, i) in shownCards" :key="i" cols="12">
                <v-card color="white" class="padding-card">
                  <div class="d-flex flex-no-wrap justify-space-between">
                    <v-list-item>
                      <v-list-item-avatar>
                        <img alt="profile" :src="imageDefaul" />
                      </v-list-item-avatar>

                      <v-list-item-content style="margin-left: 15px">
                        <v-list-item-title
                          class="title-text-info"
                        >{{spend.concept.split(' ').slice(0, 5).join(' ') + '...'}}</v-list-item-title>
                        <v-list-item-subtitle>{{spend.description.split(' ').slice(0, 5).join(' ') + '...'}}</v-list-item-subtitle>
                        <span style="font-size: 12px" v-html="$dayjs(spend.fecha_gasto).format('llll')"></span>
                      </v-list-item-content>

                      <v-list-item-action>
                        <v-list-item-action-text class="title-text-info">{{
                          $currencyNoDec.format(spend.amount)
                        }}</v-list-item-action-text>
                        <ModalSpend :post="spend" @on-update="fetchPayments(dates)" @on-close="fetchPayments(dates)"/>
                      </v-list-item-action>
                    </v-list-item>
                  </div>
                </v-card>
              </v-col>
            </v-row>
             <div class="text-center">
              <v-pagination v-model="page" :length="length"></v-pagination>
            </div>
          </v-container>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="12">
          <v-card color="white" class="padding-card">
            <div style="display: flex">
              <p class="title-user-scr">
                <v-icon> mdi-cog-sync </v-icon> Tipos de egreso
              </p>
              <ModalNewSpendType @getPaymentTypes="getPaymentTypes" />
            </div>

            <v-simple-table class="text-lg">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th id=""  class="text-left">#</th>
                    <th id=""  class="text-left">Concepto</th>                 
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in paymentTypes" :key="index">
                    <td style="width: 5%"> {{ item.id }} </td>
                    <td style="width: 30%">{{ item.name }}</td>
                  
                    <td style="width: 5%">
                      <ModalEditSpendType :tipo="item" @getPaymentTypes="getPaymentTypes"/>                      
                    </td>
                    <td style="width: 5%">
                      <v-icon color="red" @click="delspendtype(item.id)">mdi-delete</v-icon>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
      </v-col>
      </v-row>

    </div>
  </v-app>
</template>

<script>
import adminSuppliersService from '@/services/admin/supplierPayments';

import RegisterSpendForm from '@/components/RegisterSpendForm.vue';
import ModalSpend from '@/components/ModalSpend.vue';
import DateSelect from '@/components/DateSelect.vue';
import ModalNewSpendType from '../../components/ModalNewSpendType.vue';
import ModalEditSpendType from '../../components/ModalEditSpendType.vue';

export default {
  props: {
    request: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    RegisterSpendForm,
    ModalSpend,
    DateSelect,
    ModalNewSpendType,
    ModalEditSpendType
  },
  data() {
    return {
    page: 1,
    paymentItems: [],
    dates: [this.$dayjs().subtract(30, 'day').format('YYYY-MM-DD'), this.$dayjs().format('YYYY-MM-DD')],
    headline: ['Fecha gasto', 'Concepto', 'Descripción', 'Proveedor', 'Status',  'Tipo de gasto', 'Tipo de egreso', 'Cantidad', 'Número cheque'],
    fields: ['fecha_gasto', 'concept', 'description', 'supplier', 'status', 'tipo_gasto', 'tipo_egreso', 'amount', 'referencia'],    
    paymentTypes: [],
  }
  },
  created() {
    this.fetchPayments(this.dates);
    this.getPaymentTypes();
  },
  computed: {
    total() {
      if (!this.paymentItems.length) return 0;
      const reducer = (a, b) => a + b.amount;
      return this.paymentItems.reduce(reducer, 0);
    },
    imageDefaul() {
      return require('@/assets/images/avatar_dz.jpg');
    },
    length() {
      return Math.ceil(this.paymentItems.length / 8);
    },

    shownCards() {
      const { page, paymentItems } = this;
      const number = 8; // Numero de elementos a mostrar por página
      return paymentItems.slice((page - 1) * number, page * number);
    },
  },
  methods: {
    fetchPayments(dates) {
      if (dates.length === 2) {
        this.dates = dates;
        const startDate = dates[0];
        const endDate = dates[1];
        adminSuppliersService.search({ startDate, endDate }).then((response) => {
          this.paymentItems = response.data;
        });
      }
    },
    getPaymentTypes() {
      adminSuppliersService.paymentTypes().then((response) => {
        this.paymentTypes = response.data;
      });
    }, 
    exportToCsv() {
      if (!this.paymentItems || this.paymentItems.length === 0) {
        alert('No data available for export.');
        return;
      }

      // Prepare CSV data
      const headers = this.headline.join(','); // Convert fields to CSV header row
      const rows = this.paymentItems.map(row => {
        return this.fields.map(field => `"${row[field] || ''}"`).join(',');
      });
      const csvContent = [headers, ...rows].join('\n');

      // Create a Blob and trigger download
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);

      link.setAttribute('href', url);
      link.setAttribute('download', 'egresos.csv');
      link.style.visibility = 'hidden';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    delspendtype(id) {
      this.$swal({
      title: '¿Estás seguro?',
      text: 'Este registro se eliminará permanentemente.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, borrar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        adminSuppliersService.delSpendType(id)
          .then(() => {
            this.$swal('¡Eliminado!', 'El registro ha sido borrado.', 'success');
            this.getPaymentTypes(); // refrescar lista
          })
          .catch((error) => {
            console.error(error);
            this.$swal('Error', 'No se pudo eliminar el registro, puede tener egresos asociados', 'error');
          });
        }
      });
    },    
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/style.scss';
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td[data-v-3f35d354], .v-data-table > .v-data-table__wrapper > table > thead > tr > td[data-v-3f35d354], .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td[data-v-3f35d354] {
    font-size: 1rem;
    height: 28px;
}
</style>